import React from 'react';
import MenuItems from './components/includes/MenuItems';
import AboutPageContextProvider from './context/AboutPageContextProvider';
import HomePageContextProvider from './context/HomePageContextProvider';
import PortfolioPageContextProvider from './context/PortfolioPageContextProvider';

const App = () =>{
  return(
    <>
    <HomePageContextProvider>
      <AboutPageContextProvider>
        <PortfolioPageContextProvider>
          <MenuItems/>
      </PortfolioPageContextProvider>
      </AboutPageContextProvider>
    </HomePageContextProvider>
    </>
  )
}
export default App;